import React, { Component } from 'react';

import Tooltip from "rc-tooltip";

class TableRowOrigine extends Component {
  render() {

    var overlayContent = this.props.origine.Famille + ' / ' + this.props.origine.SousFamille + ' / ' + this.props.origine.Origine;

    return (<Tooltip trigger={['hover']} placement='left' overlay={<div>{overlayContent}</div>}>
      <span>{this.props.origine.Famille} / {this.props.origine.SousFamille}</span>
    </Tooltip>)
  }
}

export default TableRowOrigine;
